import Spinner from 'src/javascripts/components/utilities/Spinner';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import * as filestack from 'filestack-js';
import * as fileUpload from 'blueimp-file-upload/js/jquery.fileupload.js';

export default function() {

  // Upload file
  $('.imports-filepicker').each(function(i, elem) {
    let fileInput     = $(elem);
    let env           = fileInput.data("env");
    let accountUrl       = fileInput.data("account-url");
    var progressBar   = $("<div class='bar'></div>");
    var barContainer  = $("<div class='progress'></div>").append(progressBar);
    $('#fileUploadProgress').append(barContainer);
    fileInput.fileupload({
      fileInput:        fileInput,
      url:              fileInput.data('url'),
      type:             'POST',
      autoUpload:       true,
      formData:         fileInput.data('form-data'),
      paramName:        'file', // S3 does not like nested name fields i.e. name="user[avatar_url]"
      dataType:         'XML',  // S3 returns XML if success_action_status is set to 201
      replaceFileInput: false,
      progressall: function (e, data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
        progressBar.css('width', progress + '%')
      },
      start: function (e) {
        progressBar.
          css('background', '#8c81d1').
          css('display', 'block').
          css('width', '0%').
          text("Loading...");
      },
      done: function(e, data) {
        progressBar.text("Uploading done");

        // extract key from response
        let key = $(data.jqXHR.responseXML).find("Key").text();
        let submitUrl = $('.imports-filepicker').attr('data-submit-url');

        // Set spinner so user knows in progress
        $('.filepicker-container .filepicker-label').addClass('opaque');
        Spinner($('.filepicker-container'));

        // Check whether uploaded file is xlsx
        if (key.slice(-5) !== '.xlsx') {
          ToastCustom({title: 'Ethos', message: 'Only .xlsx files allowed', delay: 8000});

        } else {
          let formData = {}
          formData['file'] = {}
          formData['file']['key'] = key;

          // Update local attribute
          return $.ajax({
            type: 'POST',
            url: submitUrl,
            dataType: "application/json",
            data: formData,
            complete(result) { 
              let url = JSON.parse(result.responseText).url;
              return Turbo.visit(url);
            },
          });

        }

      },
      fail: function(e, data) {
        progressBar.
          css("background", "red").
          text("Failed");
      }
    });
  })


}